import React, { useMemo } from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { colors, mapGradYearsToClassYearNames } from './util'

const baseCircleStyles = {
  height: 18,
  width: 18,
  borderRadius: 9,
}
const useStyles = makeStyles((theme) => ({
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    fontSize: 14,
    marginLeft: theme.spacing(1),
  },
  seniorCircle: {
    ...baseCircleStyles,
    backgroundColor: colors.seniors,
  },
  juniorCircle: {
    ...baseCircleStyles,
    backgroundColor: colors.juniors,
  },
  sophomoreCircle: {
    ...baseCircleStyles,
    backgroundColor: colors.sophomores,
  },
  freshmenCircle: {
    ...baseCircleStyles,
    backgroundColor: colors.freshmen,
  },
}))

const Legend = ({ seniorGradYear, gradYearCounts, total }) => {
  const styles = useStyles()
  const classYearCounts = useMemo(
    () => mapGradYearsToClassYearNames(seniorGradYear, gradYearCounts),
    [seniorGradYear, gradYearCounts],
  )
  const renderAsPercent = (count) => `${count && total ? ((count / total) * 100).toFixed() : 0}%`

  return (
    <Box>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          className={styles.labelContainer}
        >
          <Box className={styles.seniorCircle} />
          <Typography
            variant="body1"
            className={styles.label}
          >
            Seniors ({renderAsPercent(classYearCounts.seniors)})
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          className={styles.labelContainer}
        >
          <Box className={styles.juniorCircle} />
          <Typography
            variant="body1"
            className={styles.label}
          >
            Juniors ({renderAsPercent(classYearCounts.juniors)})
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          className={styles.labelContainer}
        >
          <Box className={styles.sophomoreCircle} />
          <Typography
            variant="body1"
            className={styles.label}
          >
            Sophomores ({renderAsPercent(classYearCounts.sophomores)})
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          className={styles.labelContainer}
        >
          <Box className={styles.freshmenCircle} />
          <Typography
            variant="body1"
            className={styles.label}
          >
            Freshmen ({renderAsPercent(classYearCounts.freshmen)})
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

Legend.propTypes = {
  seniorGradYear: PropTypes.number.isRequired,
  gradYearCounts: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
}

export default Legend
